import {EditBundleFormValues} from "../types";
import {UpdateSessionData} from "../../../../features/sessions";
import {editSessionDto} from "../../editService/edit-service-service";

export function editBundleV2Dto(values: EditBundleFormValues): UpdateSessionData {
  return {
    ...editSessionDto(values),
    noOfSessions: Number(values.numberOfSessions),
    bookingInterval: values.bookingInterval,
    isPaused: values.isPaused,
  };
}
